export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const WHATSAPP_NUMBER = "34667312553";
export const PICHONTEAM_URL = "https://www.pichonteam.es";
export const LA_PATRONA_URL = "https://www.lapatronaeventos.es";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const photoUrl = (url) => (url?.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url);
